import { render, staticRenderFns } from "./BaseDescription.vue?vue&type=template&id=20d8023b"
import script from "./BaseDescription.vue?vue&type=script&lang=js"
export * from "./BaseDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports